/// <reference path='../../../typings/browser.d.ts' />

namespace Application.Controllers {
  'use strict';

  import ConnectionRoom = Models.ConnectionRoom;
  import IStreamPipe = Application.Models.IStreamPipe;

  export interface IRetakeDoneModalScope extends ng.IScope {
    retakeInfo: string;
    passphraseInfo: string;
    sink: number;
    streamDetails: () => void;
    modalClose: () => void;
  }

  /**
   * RetakeController class
   */
  export class RetakeDoneController {
    public static templateURL: string = 'decorators/modals/retake-done-modal.html';
    public static ID: string = '#id-retake-done-modal';
    public static $name: string = 'retakeDoneModalController';
    public connectionRooms: ConnectionRoom[];
    public static $inject: string[] = [
      '$scope',
      'close',
      '$timeout',
      'retakeInfo',
      'passphraseInfo',
      'sink',
      'streamPipeService',
      '$window',
    ];

    private scope: IRetakeDoneModalScope;
    private close: (parameters: ngModal.ICloseParameters) => void;

    /**
     * Constructor
     */
    constructor(
        $scope: IRetakeDoneModalScope,
        close: (parameters: ngModal.ICloseParameters) => void,
        $timeout: ng.ITimeoutService,
        retakeInfo: string,
        passphraseInfo: string,
        sink: number,
        private streamPipeService: Services.StreamPipeService,
        private $window: ng.IWindowService,
    ) {
      this.scope = $scope;
      this.scope.retakeInfo = retakeInfo;
      this.scope.passphraseInfo = passphraseInfo;
      this.scope.sink = sink;
      $timeout(() => {
        window.altair_admin_common_init();
      }, 500);

      this.close = close;

      this.scope.modalClose = (): void => {
        this.close(undefined);
      };

      this.scope.streamDetails = async (): Promise<void> => {
        let stream: IStreamPipe[] = await this.streamPipeService.getStreamPipeByDestinationBlockIdPromise(this.scope.sink);
        let streamId: number = Number(stream[0].href.split("/").pop());
        this.$window.location.href = '/#!/stream/' + streamId;
      };

    }
  }

}
